import { Flex } from '@grupoboticario/flora-react';
import { RichText } from 'prismic-reactjs';

import { ResponsiveFloraTypography } from 'components';
import config from 'config';

import Styles from './Reward.styles';
import { useLoyaltyIncentiveCampaign } from '../../hooks';

export const StaticReward = () => {
  const { data: incentiveCampaign, isResultActive } = useLoyaltyIncentiveCampaign();

  return (
    <Flex direction='column' gap='$6'>
      <Flex direction='column' gap='$4'>
        <ResponsiveFloraTypography fontSize='subtitle' fontWeight='bold' as='h3'>
          Premiação TOP {incentiveCampaign?.limit}{' '}
          {config.communication.userNamingConvention.plural} por faixa
        </ResponsiveFloraTypography>

        {isResultActive ? (
          <ResponsiveFloraTypography color='$nonInteractivePredominant'>
            Confira os prêmios dos TOP {incentiveCampaign?.limit}!
          </ResponsiveFloraTypography>
        ) : (
          <ResponsiveFloraTypography color='$nonInteractivePredominant'>
            Durante o período da campanha, invista em presentes de Dia das Mães e/ou itens de
            maquiagem e produtos da categoria Facial e conquiste prêmios incríveis!
            <br />
            Quanto mais você comprar, maiores serão suas chances e melhor será sua premiação!
            <br />
            <br />
            Confira os prêmios que você pode ganhar ao estar entre os TOP {
              incentiveCampaign?.limit
            }{' '}
            {config.communication.userNamingConvention.plural} da sua faixa:
          </ResponsiveFloraTypography>
        )}
      </Flex>

      <Styles.RewardWrapper>
        {incentiveCampaign?.reward
          ?.slice()
          .reverse()
          .map((reward) => (
            <Styles.RewardCard key={`${reward.title}-reward-incentive`}>
              <Flex gap='$4' align='self-start'>
                <Styles.Image src={reward.image?.url} alt='' />

                <Styles.RewardInfo>
                  <ResponsiveFloraTypography
                    fontSize='bodyLargeShort'
                    fontWeight='bold'
                    color='$nonInteractiveEmphasis'
                  >
                    {reward.title}
                  </ResponsiveFloraTypography>

                  <ResponsiveFloraTypography>
                    <RichText render={reward.description} />
                  </ResponsiveFloraTypography>
                </Styles.RewardInfo>
              </Flex>
            </Styles.RewardCard>
          ))}
      </Styles.RewardWrapper>
    </Flex>
  );
};
